export enum UserActionType {
    CREATE_USER = 'CREATE_USER',
    DELETE_USER = 'DELETE_USER',
    GET_ALL_USERS = 'GET_ALL_USERS',
    GET_USERS_ROLE_USER = 'GET_USERS_ROLE_USER',
    UPDATE_USER = 'UPDATE_USER',
    UPDATE_MULTIPLE_USER = 'UPDATE_MULTIPLE_USER',
    GET_USER_BY_ID = 'GET_USER_BY_ID',
    GET_USERS_WITH_ACTIVE_PROJECTS = 'GET_USERS_WITH_ACTIVE_PROJECTS',
    GET_USERS_WITH_PROFILE_PICTURES = 'GET_USERS_WITH_PROFILE_PICTURES',
}
